/** Os mesmos números do protótipo (`_dados/hoteis.ts`): 1,5 km é o teto do que
 *  alguém anda de sapato de reunião, 4,8 km/h é passo de calçada com semáforo e
 *  15 km/h é a velocidade efetiva de São Paulo em horário comercial — 30 faria o
 *  card prometer um trajeto que o trânsito não entrega.
 *
 *  Uma função só para o CARD (`hotelTravelLabels`) e para a cena do agente de
 *  hotel (`hotelSceneLines`, no agents): em prod (18/09/2026) o agente disse
 *  "8 minutos de carro" para hotéis a 0,2 km que o card mostrava como "3 min
 *  a pé" — duas réguas para o mesmo número. */
const WALKING_LIMIT_KM = 1.5;
const WALKING_KMH = 4.8;
const DRIVING_KMH = 15;

export type HotelTravelEstimate = { minutes: number; mode: 'foot' | 'car' };

/** Tempo estimado até a âncora a partir da distância: a pé até 1,5 km, de
 *  carro acima. Minuto arredondado e nunca ZERO — "0 min" leria como "é aqui". */
export function hotelTravelEstimate(km: number): HotelTravelEstimate {
  const mode = km <= WALKING_LIMIT_KM ? 'foot' : 'car';
  const minutes = Math.round((km / (mode === 'foot' ? WALKING_KMH : DRIVING_KMH)) * 60);
  return { minutes: Math.max(1, minutes), mode };
}
